import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {IProduct} from '../../../../shared/models';
import {UtilsService} from '../../../../shared/services';
import { smoothFade } from './animation';
import { Location } from '@angular/common';
import { ImageGalleryModalComponent } from 'src/app/shared/components/image-gallery-modal/image-gallery-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-product-features-new',
  templateUrl: './product-features-new.component.html',
  styleUrls: ['./product-features-new.component.less'],
  animations: [smoothFade]
})
export class ProductFeaturesNewComponent implements OnInit {

    @Input() product: IProduct;
    @Input() productSpecs: any;
    @Input() description: any;
    @Output() emitScroll = new EventEmitter();

    dimensionExist = false;
    featuresExist = false;
    assemblyExist = false;
    careExist = false;
    returnPolicyExist = false;
    descriptionExist = false;


    dimensionExpanded = false;
    featuresExpanded = false;
    assemblyExpanded = false;
    careExpanded = false;
    returnPolicyExpanded = false;
    descriptionExpanded = false;
    specExpanded = false;

    isSingleDimension: boolean;

    activeFeatureTab = 'features';
    features: any;
    assembly: any;
    care: any;
    dimensionGallery: string[]=[];
  slideIndex = 0;
productSpecExist = false;

    constructor(
        private utils: UtilsService,private location:Location,private matDialog:MatDialog
    ) {
    }
    ngOnChanges(changes:SimpleChanges){
      if(changes['productSpecs']){
        this.productSpecs = changes['productSpecs'].currentValue;
        this.productSpecExist  = this.productSpecs && Object.keys(this.productSpecs).length > 0;
      }
    }


  get displaySpecs() {
    return Object.entries(this.productSpecs)
      .filter(([_, value]) => value !== null && value !== '' && _.toLowerCase() !== 'id') // Filter out null/empty
      .map(([key, value]) => ({
        label: this.formatLabel(key),
        value: (value == 0 || !value) ? 'No': (value==1 || value == true) ? 'Yes' : value.toString()
      }));
  }

formatLabel(key: string): string {
  return key
    .replace(/_/g, ' ') // replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase()) // capitalize first letters
    .replace(/\b(Id)\b/gi, 'ID') // replace Id with ID
    .replace(/\b(Sku)\b/gi, 'SKU'); // replace Sku with SKU
}


    ngOnInit() {
        this.isSingleDimension = this.product.dimension.length === 1;
        this.featuresExist = this.utils.checkDataLength(this.product.features);
        if (this.product.product_assembly != null) {
            this.assemblyExist = this.utils.checkDataLength(
                this.product.product_assembly
            );
        }
        if (this.product.product_care != null) {
            this.careExist = this.utils.checkDataLength(this.product.product_care);
        }
        this.returnPolicyExist = !!this.product.return_policy;
        this.dimensionExist = this.product.dimension.length > 0;
        this.assembly = this.utils.compileMarkdownText(this.product.product_assembly);
        this.care = this.utils.compileMarkdownText(this.product.product_care);
        this.features = this.utils.compileMarkdown(this.product.features);
        this.setFeatureTab();
        this.descriptionExpanded = true;
           this.dimensionGallery = this.product.product_images_dims;
 
      if(this.dimensionGallery?.length>0){
     setTimeout(() => {
      this.currentSlide(1,'dims');
    }, 0);
      }
    }

    selectFeatureTab(tab,expanded) {
        this.activeFeatureTab = tab;
        // if(expanded){
            this.emitScroll.emit();
        // }
    }

    get isPreview(){
      return this.location.path().match(/preview/) !== null;
    }

    setFeatureTab(){
       if(this.featuresExist){
            this.activeFeatureTab = 'features';
        }else  if(this.dimensionExist){
            this.activeFeatureTab = 'dimensions';
        }else if(this.assemblyExist){
            this.activeFeatureTab = 'assembly';
        }else if(this.careExist){
            this.activeFeatureTab = 'care';
        }else if(this.returnPolicyExist){
            this.activeFeatureTab = 'returns';
        } else if(this.productSpecExist){
            this.activeFeatureTab = 'specifications';
        }
    }

  plusSlides(n: number,type) {
    this.showSlides((this.slideIndex += n),type);
  }
  currentSlide(n,type) {
    this.showSlides((this.slideIndex = n),type);
  }
  showSlides(n,type) {
    let i;
    let slides:any;
    let dots:any;

  slides = document.getElementsByClassName(
     type==='dims'? "pDimsSlides": "pSlides"
    ) as HTMLCollectionOf<HTMLElement>;

    if (slides.length > 0) {
        dots = type==='dims'? document.getElementsByClassName("dims-dot"):document.getElementsByClassName("dot");
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active-dot", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      if (dots && dots[this.slideIndex - 1]) {
        dots[this.slideIndex - 1].className += " active-dot";
      }
    }
  }
    openGallery(img:string[]): void {
      this.matDialog.open(ImageGalleryModalComponent, {
        data: { gallery: img },
        panelClass: 'full-screen-dialog',
        maxWidth: '100vw',
        height: '0',
        autoFocus: false,
        restoreFocus: false
      });
    }
}
